import { render, staticRenderFns } from "./MessageIqSignupLayout.vue?vue&type=template&id=39917cdc"
import script from "./MessageIqSignupLayout.vue?vue&type=script&lang=js"
export * from "./MessageIqSignupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports